import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreModule } from '../../core/core.module';
import { SharedModule } from '../../shared/shared.module';
import { GradeSystemService } from './grade-system/grade-system.service';
import { GradeService } from './grade-system/grade.service';

@NgModule({
    imports: [CoreModule, SharedModule, CommonModule],
    providers: [GradeSystemService, GradeService],
})
export class AdminCoreModule {}
